import { ContainerMediaData } from "@/src/components/organism/ViewPhotoCollectionDialog";
import {
  ContainerDetailViewDto,
  ContainerListViewDto,
  ContainerMediaType,
  ContainerStatusType,
  TaskPhotoTypeRequestResponseDto,
  TaskWeighingStatusType,
} from "@/src/store/apis/tasks/taskDetail/interface";
import { ReactNode } from "react";

export type ContainerAccordionRole = "exporter" | "importer";

export type TaskContainerDialogType = "VIEW_PHOTO" | "EDIT_CONTAINER" | null;

export type EditContainerTabType = "PHOTO" | "WEIGHT";

export interface ContainerAccordionItemProps {
  role: ContainerAccordionRole;
  containerId: number;
  containerNo?: string;
  sealNo?: string;
  containerCheckList: number[];
  index: number;
  extraRemark: string | null;
  onCheckChange?: (id: number, checked: boolean) => void;
  containerStatus?: ContainerStatusType;
  containerWeighingStatus?: TaskWeighingStatusType;
  isUnableEdit?: boolean;
  photoTypeRequests?: TaskPhotoTypeRequestResponseDto[];
}

export interface ImageResourceItem {
  isUsed: boolean;
  imageList: (string | undefined)[];
  title: ReactNode;
  subTitle?: string;
  remark?: string;
  displayOrder: number;
  mediaDataList: ContainerMediaData[];
}

export const containerCountMediaMap = {
  containerSampleBaleMediasCount: "sampleBaleSimpleContainerMedias",
  containerEmptyMediasCount: "emptySimpleContainerMedias",
  containerQuarterLoadedMediasCount: "quarterLoadedSimpleContainerMedias",
  containerHalfLoadedMediasCount: "halfLoadedSimpleContainerMedias",
  containerFullLoadedMediasCount: "fullLoadedSimpleContainerMedias",
  containerOneDoorClosedMediasCount: "oneDoorClosedSimpleContainerMedias",
  containerBothDoorsClosedMediasCount: "bothDoorsClosedSimpleContainerMedias",
  containerCloseUpSealMediasCount: "closeUpSealSimpleContainerMedias",
  containerExtraMediasCount: "extraSimpleContainerMedias",
} as const;

export const FALLBACK_PHOTO_TYPE_TITLES: Partial<Record<ContainerMediaType, string>> = {
  CLOSE_UP_SEAL: "Close Up Seal",
  EXTRA: "Extra",
};

export const DEFAULT_DISPLAY_ORDER = 999;

export const PHOTO_TYPE_CODES = [
  "SAMPLE_BALE", "EMPTY", "QUARTER_LOADED", "HALF_LOADED",
  "FULL_LOADED", "ONE_DOOR_CLOSED", "BOTH_DOORS_CLOSED",
  "CLOSE_UP_SEAL", "EXTRA",
  "CUSTOM_1", "CUSTOM_2", "CUSTOM_3", "CUSTOM_4",
  "CUSTOM_5", "CUSTOM_6", "CUSTOM_7", "CUSTOM_8",
] as const;

export type PhotoTypeCodeFromList = typeof PHOTO_TYPE_CODES[number];

export const isPhotoTypeCode = (value: string): value is PhotoTypeCodeFromList =>
  (PHOTO_TYPE_CODES as readonly string[]).includes(value);

export const countKeyConvertToContainerType = (
  countKey: keyof typeof containerCountMediaMap
): ContainerMediaType | undefined => {
  const mapping: Record<keyof typeof containerCountMediaMap, ContainerMediaType> = {
    containerSampleBaleMediasCount: "SAMPLE_BALE",
    containerEmptyMediasCount: "EMPTY",
    containerQuarterLoadedMediasCount: "QUARTER_LOADED",
    containerHalfLoadedMediasCount: "HALF_LOADED",
    containerFullLoadedMediasCount: "FULL_LOADED",
    containerOneDoorClosedMediasCount: "ONE_DOOR_CLOSED",
    containerBothDoorsClosedMediasCount: "BOTH_DOORS_CLOSED",
    containerCloseUpSealMediasCount: "CLOSE_UP_SEAL",
    containerExtraMediasCount: "EXTRA",
  };
  return mapping[countKey];
};

export type SelectedLoadingData = ContainerListViewDto | ContainerDetailViewDto | null;
